import e, { useMemo as t, useState as n } from "react";
import { Trans as r, useI18nContext as i } from "@ecg-marktplaats/js-react-i18n";
import { Asset as a, BasicModal as o, ButtonIcon as s, Dropdown as c, EmptyState as l, Icon as u, StarRating as d, Tab as f, TabPanel as p, Tabs as m, TertiaryButton as h, TextLarge as g, TextRegular as _ } from "@hz-design-system/web-ui";
var v = {
	heading: "_heading_1anig_2",
	headingBody: "_headingBody_1anig_11",
	providerLogo: "_providerLogo_1anig_18",
	logo: "_logo_1anig_24",
	headingImage: "_headingImage_1anig_30",
	summary: "_summary_1anig_35",
	externalReviewsContentRoot: "_externalReviewsContentRoot_1anig_40",
	externalReviewsHeadingName: "_externalReviewsHeadingName_1anig_44",
	ratingText: "_ratingText_1anig_48",
	externalReviewHeadingMeta: "_externalReviewHeadingMeta_1anig_53",
	review: "_review_1anig_58",
	reviewerName: "_reviewerName_1anig_64",
	reviewerPlace: "_reviewerPlace_1anig_73",
	reviewMetaInfo: "_reviewMetaInfo_1anig_78",
	reviewText: "_reviewText_1anig_85",
	footerButton: "_footerButton_1anig_89",
	locationDropdown: "_locationDropdown_1anig_94",
	"hz-Dropdown-formControl": "hz-Dropdown-formControl",
	internalReviews: "_internalReviews_1anig_101",
	emptyStateWrapper: "_emptyStateWrapper_1anig_109"
}, y = {
	GOOGLE_REVIEWS: {
		logo: "logo-googlemaps",
		source: "Google Maps",
		sourceAsset: "social-badge-google"
	},
	KLANTENVERTELLEN: {
		logo: "logo-klantenvertellen",
		source: "Klantenvertellen.nl"
	}
}, b = ({ sellerName: t, reviewsData: n, onExternalReviewsUrlClick: o }) => {
	let { t: c } = i(), { rating: l = 0, lastReviews: f = [], externalReviewsUrl: p, numberOfReviews: m, reviewSystem: b = "", sorting: x = "" } = n, S = y[b];
	return /* @__PURE__ */ e.createElement("div", { className: v.externalReviewsContentRoot }, /* @__PURE__ */ e.createElement("div", { className: v.heading }, /* @__PURE__ */ e.createElement("div", { className: v.headingBody }, /* @__PURE__ */ e.createElement(g, {
		as: "div",
		className: `${v.externalReviewsHeadingName} TextEllipsis`
	}, t), /* @__PURE__ */ e.createElement("div", { className: v.summary }, /* @__PURE__ */ e.createElement(u, {
		name: "saved",
		color: "text-brand-primary"
	}), /* @__PURE__ */ e.createElement(g, { as: "strong" }, l.toFixed(1)), /* @__PURE__ */ e.createElement(g, { className: v.ratingText }, c("reviewsDialogUi:external.reviewCount", { count: m }))), /* @__PURE__ */ e.createElement("div", { className: v.externalReviewHeadingMeta }, c("reviewsDialogUi:external.providedBy", { provider: S?.source }))), S?.logo && /* @__PURE__ */ e.createElement("div", { className: v.providerLogo }, /* @__PURE__ */ e.createElement(a.Square, {
		size: "xxl",
		name: S.logo,
		className: v.logo
	}))), /* @__PURE__ */ e.createElement(_, { utilities: ["marginTopM"] }, /* @__PURE__ */ e.createElement(r, { i18nKey: `reviewsDialogUi:external.sorting.${x.toLowerCase()}` })), f.map((t, n) => /* @__PURE__ */ e.createElement("div", {
		key: `${n}-${t.name}`,
		className: v.review
	}, /* @__PURE__ */ e.createElement("div", { className: v.reviewerName }, t.name), /* @__PURE__ */ e.createElement("div", { className: v.reviewMetaInfo }, !!t.place && /* @__PURE__ */ e.createElement("span", { className: v.reviewerPlace }, t.place), !!t.date && /* @__PURE__ */ e.createElement("span", null, t.date), !!S?.sourceAsset && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(r, {
		i18nKey: "reviewsDialogUi:external.reviewOn",
		tagName: "span"
	}), /* @__PURE__ */ e.createElement(a.Square, {
		name: S.sourceAsset,
		size: "s"
	}), /* @__PURE__ */ e.createElement("span", null, S?.source))), /* @__PURE__ */ e.createElement(d, {
		label: "",
		rating: t.rating
	}), /* @__PURE__ */ e.createElement("p", { className: v.reviewText }, "\"", t.text, "\""))), p && /* @__PURE__ */ e.createElement("div", { className: v.footerButton }, /* @__PURE__ */ e.createElement(h, {
		as: "a",
		href: p,
		target: "_blank",
		rel: "nofollow",
		onClick: o
	}, /* @__PURE__ */ e.createElement(s, { name: "external-link" }), c("reviewsDialogUi:external.readMore"))));
}, x = "INTERNAL_REVIEWS", S = (e) => [e.sellerName, e.postCode].filter(Boolean).join(" "), C = (e, t) => {
	let n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set();
	for (let i of e) {
		let e = i.sellerName ?? t;
		n.has(e) ? r.add(e) : n.add(e);
	}
	return e.map((e, n) => {
		let i = e.sellerName ?? t;
		return {
			label: r.has(i) && e.postCode ? `${i} (${e.postCode})` : i,
			value: String(n)
		};
	});
}, w = ({ onClose: r, onTabClick: a, reviews: s, sellerName: u, internalReviewsUrl: d, onExternalReviewsUrlClick: h, onLocationChange: g, onLocationFocus: _, disableMultiLocation: y = !1, initialSellerName: w, initialPostcode: T }) => {
	let { t: E } = i(), [D, O] = n(0), [k, A] = n({}), j = t(() => {
		let e = /* @__PURE__ */ new Map();
		for (let t of s.filter((e) => e.reviewSystem === x || !!e.numberOfReviews)) {
			let n = t.reviewSystem ?? "";
			e.has(n) || e.set(n, []), e.get(n)?.push(t);
		}
		return Array.from(e.entries()).map(([e, t]) => ({
			reviewSystem: e,
			entries: y ? t.slice(0, 1) : t
		}));
	}, [s, y]);
	if (j.length === 0) return /* @__PURE__ */ e.createElement(o, {
		isOpen: !0,
		onClose: r,
		title: E("reviewsDialogUi:dialog.title"),
		size: "l"
	}, /* @__PURE__ */ e.createElement("div", { className: v.emptyStateWrapper }, /* @__PURE__ */ e.createElement(l, {
		title: E("reviewsDialogUi:dialog.empty.title"),
		illustration: "empty-state-star"
	})));
	let M = j.length > 1, N = (e) => {
		a?.(j[e]?.reviewSystem), O(e);
	}, P = (e) => {
		let t = k[e.reviewSystem];
		if (t !== void 0) {
			let n = parseInt(t, 10);
			if (!isNaN(n) && n >= 0 && n < e.entries.length) return n;
		}
		if (w || T) {
			let t = [w, T].filter(Boolean).join(" "), n = e.entries.findIndex((e) => S(e) === t);
			if (n !== -1) return n;
		}
		return 0;
	};
	return /* @__PURE__ */ e.createElement(o, {
		isOpen: !0,
		onClose: r,
		title: E("reviewsDialogUi:dialog.title"),
		size: "l"
	}, M && /* @__PURE__ */ e.createElement(m, {
		activeTab: D,
		setActiveTab: N
	}, j.map((t) => /* @__PURE__ */ e.createElement(f, {
		key: t.reviewSystem,
		label: E(`reviewsDialogUi:dialog.reviewSystem.${t.reviewSystem}`)
	}))), j.map((t, n) => {
		let r = t.entries.length > 1, i = P(t), a = t.entries[i], o = C(t.entries, u);
		return /* @__PURE__ */ e.createElement(p, {
			key: t.reviewSystem,
			activeTab: D,
			tab: n
		}, r && /* @__PURE__ */ e.createElement("div", { className: v.locationDropdown }, /* @__PURE__ */ e.createElement(c, {
			labelText: E("reviewsDialogUi:dialog.location.label"),
			options: o,
			value: String(i),
			onFocus: _,
			onChange: (e) => {
				let n = e.target.value;
				A((e) => ({
					...e,
					[t.reviewSystem]: n
				}));
				let r = t.entries[parseInt(n, 10)];
				g?.(r?.sellerName ?? u);
			}
		})), a && (a.reviewSystem === x ? /* @__PURE__ */ e.createElement("iframe", {
			className: v.internalReviews,
			src: d
		}) : /* @__PURE__ */ e.createElement(b, {
			sellerName: a.sellerName ?? u,
			reviewsData: a,
			onExternalReviewsUrlClick: h
		})));
	}));
};
//#endregion
export { w as ReviewsDialog };

//# sourceMappingURL=index.mjs.map